"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseStringDef = void 0;
const errorMessages_1 = require("../errorMessages");
function parseStringDef(def, refs) {
    const res = {
        type: "string",
    };
    if (def.checks) {
        for (const check of def.checks) {
            switch (check.kind) {
                case "min":
                    (0, errorMessages_1.setResponseValueAndErrors)(res, "minLength", typeof res.minLength === "number"
                        ? Math.max(res.minLength, check.value)
                        : check.value, check.message, refs);
                    break;
                case "max":
                    (0, errorMessages_1.setResponseValueAndErrors)(res, "maxLength", typeof res.maxLength === "number"
                        ? Math.min(res.maxLength, check.value)
                        : check.value, check.message, refs);
                    break;
                case "email":
                    (0, errorMessages_1.setResponseValueAndErrors)(res, "format", "email", check.message, refs);
                    break;
                case "url":
                    (0, errorMessages_1.setResponseValueAndErrors)(res, "format", "uri", check.message, refs);
                    break;
                case "uuid":
                    (0, errorMessages_1.setResponseValueAndErrors)(res, "format", "uuid", check.message, refs);
                    break;
                case "regex":
                    addPattern(res, check.regex.source, check.message, refs);
                    break;
                case "cuid":
                    addPattern(res, "^c[^\\s-]{8,}$", check.message, refs);
                    break;
                case "cuid2":
                    addPattern(res, "^[a-z][a-z0-9]*$", check.message, refs);
                    break;
                case "startsWith":
                    addPattern(res, "^" + escapeNonAlphaNumeric(check.value), check.message, refs);
                    break;
                case "endsWith":
                    addPattern(res, escapeNonAlphaNumeric(check.value) + "$", check.message, refs);
                    break;
                case "trim":
                    // I have no idea why this is a check in Zod. It's a runtime string manipulation method.
                    break;
                case "datetime":
                    (0, errorMessages_1.setResponseValueAndErrors)(res, "format", "date-time", check.message, refs);
                    break;
                case "length":
                    (0, errorMessages_1.setResponseValueAndErrors)(res, "minLength", typeof res.minLength === "number"
                        ? Math.max(res.minLength, check.value)
                        : check.value, check.message, refs);
                    (0, errorMessages_1.setResponseValueAndErrors)(res, "maxLength", typeof res.maxLength === "number"
                        ? Math.min(res.maxLength, check.value)
                        : check.value, check.message, refs);
                    break;
                default:
                    ((_) => { })(check);
            }
        }
    }
    return res;
}
exports.parseStringDef = parseStringDef;
const escapeNonAlphaNumeric = (value) => Array.from(value)
    .map((c) => (/[a-zA-Z0-9]/.test(c) ? c : `\\${c}`))
    .join("");
const addPattern = (schema, value, message, refs) => {
    var _a;
    if (schema.pattern || ((_a = schema.allOf) === null || _a === void 0 ? void 0 : _a.some((x) => x.pattern))) {
        if (!schema.allOf) {
            schema.allOf = [];
        }
        if (schema.pattern) {
            schema.allOf.push(Object.assign({ pattern: schema.pattern }, (schema.errorMessage &&
                refs.errorMessages && {
                errorMessage: { pattern: schema.errorMessage.pattern },
            })));
            delete schema.pattern;
            if (schema.errorMessage) {
                delete schema.errorMessage.pattern;
                if (Object.keys(schema.errorMessage).length === 0) {
                    delete schema.errorMessage;
                }
            }
        }
        schema.allOf.push(Object.assign({ pattern: value }, (message &&
            refs.errorMessages && { errorMessage: { pattern: message } })));
    }
    else {
        (0, errorMessages_1.setResponseValueAndErrors)(schema, "pattern", value, message, refs);
    }
};
